import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, ButtonGroup, Button } from "@mui/material";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
  NavButton,
} from "../../Components/helpers/Helpers";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/axios";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

const Editar = () => {
  const navigate = useNavigate();

  const { goPanel, goTable, buildTableUrl } = useLocationHelpers();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get("id");
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [groupData, setGroupData] = useState({ id: 0, grupo: "" });

  const getData = async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_URL}/groups/edit`;

    try {
      const response = await api.post(url, { id: groupId });
      const { grupo } = response.data.group[0];

      setGroupData({ grupo });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleGroupsFormInformation = async () => {
    if (!validateFields()) {
      showValidationErrors();
      return;
    }

    const result = await Swal.fire({
      title: "¿Desea guardar los cambios?",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
      confirmButtonText: "Guardar",
      denyButtonText: "Volver",
    });

    if (result.isDenied) {
      Swal.fire("¡Los cambios no han sido guardados!", "", "info");
      return;
    }

    if (!result.isConfirmed) {
      return;
    }

    const formData = new FormData();
    formData.append("grupo", groupData.grupo.trim());
    formData.append("id", groupId);

    setIsSaving(true);
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/groups/update`,
        formData,
      );

      if (response.data.error) {
        Swal.fire({
          title: "¡No se guardaron los cambios!",
          icon: "error",
          text: "Por favor intentelo nuevamente",
          confirmButtonColor: "#1ab394",
        });
        return;
      }

      const saveResult = await Swal.fire({
        title: "¡Guardado!",
        icon: "success",
        showDenyButton: false,
        showConfirmButton: false,
        timer: 2000,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      });

      navigate("/grupos");
      // navigate("/grupos/ver?id=" + groupId);
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "No se pudo actualizar el grupo",
        confirmButtonColor: "#1ab394",
      });
    } finally {
      setIsSaving(false);
    }
  };

  // Validate required fields
  const validateFields = () => {
    return groupData.grupo.trim() !== "";
  };

  const showValidationErrors = () => {
    Swal.fire({
      title: "¡Error!",
      icon: "error",
      html: '<div style="text-align: start;">Por favor rellene el campo: <ul><li>Nombre del grupo</li></ul></div>',
      confirmButtonColor: "#1ab394",
    });
  };

  const handleChange = (event) => {
    setGroupData({
      ...groupData,
      [event.target.name]: event.target.value,
    });
  };

  // Fields for the form
  const formFields = [
    {
      name: "grupo",
      label: "Nombre",
      key: "grupo",
      type: "text",
    },
  ];

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Grupos" subTitle="Editar" />
      {isLoading && <LoadingPage heightProp="40vh" isLoading />}

      {!isLoading && (
        <Box
          component="form"
          sx={{ margin: "auto", "& > :not(style)": {} }}
          noValidate
          autoComplete="off"
          className="formMainContainer">
          <Grid
            container
            style={{ textAlign: "center" }}
            p={2}
            className="fontSize">
            {formFields.map((field, idx) =>
              field.type === "text" ? ( // Cambío "autocomplete" a "textarea" en esta lí­nea para corregir la condición duplicada
                <Grid item xs={12} sm={12} key={idx} sx={{ padding: "5px" }}>
                  <TextField
                    name={field.name}
                    label={field.label}
                    size="small"
                    value={groupData[field.name]}
                    onChange={handleChange}
                    autoComplete="new-password" // Desactiva el autofill general
                    fullWidth
                  />
                </Grid>
              ) : null,
            )}
            <Grid item xs={12}>
              <ButtonGroup
                sx={{
                  width: "100%",
                  justifyContent: "center",
                  textAlign: "center",
                  margin: "20px 5px 0px 5px",
                }}>
                <Button
                  sx={{ width: "100%" }}
                  onClick={handleGroupsFormInformation}
                  disabled={isSaving}
                  variant="outlined"
                  color="success">
                  Guardar
                </Button>
                <NavButton
                  sx={{ width: "100%" }}
                  to={buildTableUrl("grupos")}
                  onClick={() => goTable("grupos", "Grupos")}
                  variant="outlined"
                  color="error">
                  Tabla
                </NavButton>
                <NavButton
                  sx={{ width: "100%" }}
                  onClick={goPanel}
                  variant="outlined">
                  Inicio
                </NavButton>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default Editar;
